import './pagetitlewithmenu.scss';
import Menu from './menu';
import type { MenuItem } from './menu';

type Props = {
  items: MenuItem[];
  isEditMode?: boolean;
  title: string;
  titleasp?: boolean;
  parent_title?: string;
};

export default function MenuDesktop({
  title,
  items,
  isEditMode,
  titleasp,
  parent_title = '',
}: Props) {
  return (
    <div className={`page-title-wrapper`}>
      <div className="page-title">
        {titleasp ? (
          <>
            <p className="h1">{parent_title}</p>
            <h1 className="sr-only">{title}</h1>
          </>
        ) : (
          <h1>{title}</h1>
        )}
      </div>
      <div className="page-navigation">
        <Menu items={items} isEditMode={isEditMode} />
      </div>
    </div>
  );
}
